import React from "react";
import { Game } from "../../interfaces/game.interface";
import { Modal } from 'react-responsive-modal';
import { GameFeedback } from "../../components/atoms/GameFeedback";

type FeedbackModalProps = {
  game: Game | undefined;
  showFeedback: boolean;
  onCloseModal: any;
  setShowFeedback: any;
}

export const FeedbackModal = (props: FeedbackModalProps) => {
    return (
      <Modal open={props.showFeedback} onClose={props.onCloseModal} center showCloseIcon={false} classNames={{ modal: 'bg-white' }} styles={{ modal: { padding: 0, margin: 0 } }}>
        <div className="bg-dark1 p-6 flex flex-col gap-4 relative game-feedback-modal">
            <div className="absolute left-6 top-6">
                <GameFeedback gameId={props.game?.id || ''} game={props.game} setShowFeedback={props.setShowFeedback} feedbackLabel={`What Makes You Dislike ${props.game?.id}?`} showCancel={true} feedbackName='Dislike' />
            </div>

            <div className="flex justify-end space-x-1">

            </div>
        </div>
      </Modal>
    )
}